import _classCallCheck from "/Users/john/workspace/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/Users/john/workspace/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/john/workspace/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/john/workspace/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { Exception } from "../../core";
/**
 * An exception indicating the session terminated before the action completed.
 * @public
 */

export var SessionTerminatedError = /*#__PURE__*/function (_Exception) {
  _inherits(SessionTerminatedError, _Exception);

  function SessionTerminatedError() {
    _classCallCheck(this, SessionTerminatedError);

    return _possibleConstructorReturn(this, _getPrototypeOf(SessionTerminatedError).call(this, "The session has terminated."));
  }

  return SessionTerminatedError;
}(Exception);